import type { ComponentPropsWithoutRef } from 'react';
import { appViewPaths, navigateToView, type AppView } from './useAppView';

interface AppLinkProps extends Omit<ComponentPropsWithoutRef<'a'>, 'href'> {
  readonly to: AppView;
}

/** Native links support new tabs; ordinary clicks keep the workspace mounted. */
export function AppLink({ to, onClick, children, ...props }: AppLinkProps) {
  return (
    <a
      {...props}
      href={appViewPaths[to]}
      onClick={(event) => {
        onClick?.(event);
        if (
          event.defaultPrevented ||
          event.button !== 0 ||
          event.metaKey ||
          event.ctrlKey ||
          event.shiftKey ||
          event.altKey ||
          (event.currentTarget.target && event.currentTarget.target !== '_self') ||
          event.currentTarget.hasAttribute('download')
        )
          return;
        event.preventDefault();
        navigateToView(to);
      }}
    >
      {children}
    </a>
  );
}
